<div class="prose mt-6 max-w-[400px]">
  <h2 class="mb-2 flex justify-between">
    <div><i class="fa fa-exclamation-circle mr-4 text-red-500"></i>Error</div>
    <button class="cursor-pointer" (click)="closeDialog()"><i class="fa text-gray-400 fa-times"></i></button>
  </h2>
  <p>{{ message() }}</p>

  <button (click)="closeDialog()" class="block px-y py-3 center-all bg-primary text-white hover:bg-primary/90 cursor-pointer w-full rounded-xl">Close</button>
</div>
